import { Fragment, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToggleButton from 'react-toggle-button';
import {
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ButtonGroup,
  Table,
  UncontrolledTooltip,
  Badge,
  Spinner,
  Alert as RSAlert
} from "reactstrap";
import { DebounceInput } from "react-debounce-input";
import FloorplanTool from "../../floorplan-module-2.0/FloorplanTool";
import _ from "lodash";
import moment from "moment";
import DatePicker from 'react-datepicker';
import Alert from "react-s-alert-v3";
import { confirmAlert } from "react-confirm-alert";
import classnames from 'classnames';
import { AddOnAdvice, Loading, Pager, BundleInfo } from "../";
import { SalespersonEdit, PriceAdjustmentEditor } from "./";
import {api, ui_helpers, floorplan_helpers } from "../../helpers";
import { constants } from "../../utils";
import { default as useContractStore } from "./utils/useContractStore";
import Select from 'react-select';
import CurrencyInput from "react-currency-input-field";

export default function UnitInformation(props) {
  // //For FP
  // const [showEditor, setShowEditor] = useState(false);
  // const [selectedFPAddOns, setSelectedFPAddOns] = useState([]);
  // const [mfgFPAddOnOptions, setMfgFPAddOnOptions] = useState([]);
  // const [optionColors, setOptionColors] = useState([]);
  // const [bundleOptions, setBundleOptions] = useState([]);

  const contractId = useContractStore(x => x.contractId);
  const isQuote = useContractStore(x => x.isQuote);
  const isRTO = useContractStore(x => x.isRTO);
  const hideUnitType = useContractStore(x => x.hideUnitType);
  const lastPairedInventoryId = useContractStore(x => x.lastPairedInventoryId);
  const setLastPairedInventoryId = useContractStore(x => x.setLastPairedInventoryId);
  const unpairedInvList = useContractStore(x => x.unpairedInvList);
  const setUnpairedInvList = useContractStore(x => x.setUnpairedInvList);
  const enableBuildFeature = useContractStore(x => x.enableBuildFeature);
  const setEnableBuildFeature = useContractStore(x => x.setEnableBuildFeature);
  const salespeople = useContractStore(x => x.salespeople);
  const setSalespeople = useContractStore(x => x.setSalespeople);
  const addOns = useContractStore(x => x.addOns);
  const buildingOrientations = useContractStore(x => x.buildingOrientations);
  const buildingOrientation = useContractStore(x => x.buildingOrientation);
  const setBuildingOrientation = useContractStore(x => x.setBuildingOrientation);
  const deliveryInstructions = useContractStore(x => x.deliveryInstructions);
  const setDeliveryInstructions = useContractStore(x => x.setDeliveryInstructions);
  const unitPriceDisabled = useContractStore(x => x.unitPriceDisabled);
  const setAddOns = useContractStore(x => x.setAddOns);
  const addOnOptions = useContractStore(x => x.addOnOptions);
  const setAddOnOptions = useContractStore(x => x.setAddOnOptions);
  const defaultAddOns = useContractStore(x => x.defaultAddOns);
  const setDefaultAddOns = useContractStore(x => x.setDefaultAddOns); // was defaultAddonList
  const existingContractPairingContractId = useContractStore(x => x.existingContractPairingContractId);
  const setExistingContractPairingContractId = useContractStore(x => x.setExistingContractPairingContractId);
  const existingContractPairingAgreementNumber = useContractStore(x => x.existingContractPairingAgreementNumber);
  const setExistingContractPairingAgreementNumber = useContractStore(x => x.setExistingContractPairingAgreementNumber);
  const screenWarnings = useContractStore(x => x.screenWarnings);
  const setScreenWarnings = useContractStore(x => x.setScreenWarnings);
  const otherManufacturer = useContractStore(x => x.otherManufacturer);
  const setOtherManufacturer = useContractStore(x => x.setOtherManufacturer);
  const unitTypes = useContractStore(x => x.unitTypes);
  const productTypes = useContractStore(x => x.productTypes);
  const setProductTypes = useContractStore(x => x.setProductTypes);
  const subproductTypes = useContractStore(x => x.subproductTypes);
  const setSubproductTypes = useContractStore(x => x.setSubproductTypes);
  const subProducts = useContractStore(x => x.subProducts);
  const setSubProducts = useContractStore(x => x.setSubProducts);
  const isPairing = useContractStore(x => x.isPairing);
  const setIsPairing = useContractStore(x => x.setIsPairing);
  const skus = useContractStore(x => x.skus);
  const setSkus = useContractStore(x => x.setSkus); // was subProductSkuOptions
  const sku = useContractStore(x => x.sku);
  const setSku = useContractStore(x => x.setSku); // was selectedSku
  const hasSku = useContractStore(x => x.hasSku);
  const baseColors = useContractStore(x => x.baseColors);
  const setBaseColors = useContractStore(x => x.setBaseColors);
  const trimColors = useContractStore(x => x.trimColors);
  const setTrimColors = useContractStore(x => x.setTrimColors);
  const roofColors = useContractStore(x => x.roofColors);
  const setRoofColors = useContractStore(x => x.setRoofColors);
  const unitPrice = useContractStore(x => x.unitPrice);
  const setUnitPrice = useContractStore(x => x.setUnitPrice);
  const taxRate = useContractStore(x => x.taxRate);
  const setTaxRate = useContractStore(x => x.setTaxRate);
  const taxRateString = useContractStore(x => x.taxRateString);
  const setTaxRateString = useContractStore(x => x.setTaxRateString);
  const taxAmount = useContractStore(x => x.taxAmount);
  const setTaxAmount = useContractStore(x => x.setTaxAmount);
  const quoteDownPayment = useContractStore(x => x.quoteDownPayment);
  const setQuoteDownPayment = useContractStore(x => x.setQuoteDownPayment);
  const associatedBundles = useContractStore(x => x.associatedBundles);
  const setAssociatedBundles = useContractStore(x => x.setAssociatedBundles);
  const setBundlesToDelete = useContractStore(x => x.setBundlesToDelete);
  const bundlesToDelete = useContractStore(x => x.bundlesToDelete);
  const bundlePrice = useContractStore(x => x.bundlePrice);
  const setBundlePrice = useContractStore(x => x.setBundlePrice);
  const setValidationMessage = useContractStore(x => x.setValidationMessage);
  const deleteBundle = useContractStore(x => x.deleteBundle);
  const disableSale = useContractStore(x => x.disableSale);
  const setDisableSale = useContractStore(x => x.setDisableSale);
  const widths = useContractStore(x => x.widths);
  const setWidths = useContractStore(x => x.setWidths);
  const lengths = useContractStore(x => x.lengths);
  const setLengths = useContractStore(x => x.setLengths);
  const enableCustomSerialGeneration = useContractStore(x => x.enableCustomSerialGeneration);
  const setEnableCustomSerialGeneration = useContractStore(x => x.setEnableCustomSerialGeneration);
  const priceAdjustments = useContractStore(x => x.priceAdjustments);
  const setPriceAdjustments = useContractStore(x => x.setPriceAdjustments);
  const serialNumber = useContractStore(x => x.serialNumber);
  const setSerialNumber = useContractStore(x => x.setSerialNumber);
  const captiveInventoryId = useContractStore(x => x.captiveInventoryId);
  const setCaptiveInventoryId = useContractStore(x => x.setCaptiveInventoryId);
  const isNewBuild = useContractStore(x => x.isNewBuild);
  const customSerialEnabled = useContractStore(x => x.customSerialEnabled);
  const manufacturers = useContractStore(x => x.manufacturers);
  const manufacturer = useContractStore(x => x.manufacturer);
  const setManufacturer = useContractStore(x => x.setManufacturer);
  const manufacturerId = useContractStore(x => x.manufacturerId);
  const agreedPrice = useContractStore(x => x.agreedPrice);
  const inventoryId = useContractStore(x => x.inventoryId);
  const unitIsNew = useContractStore(x => x.unitIsNew);
  const setUnitIsNew = useContractStore(x => x.setUnitIsNew);
  const unitIsInventory = useContractStore(x => x.unitIsInventory);
  const setUnitIsInventory = useContractStore(x => x.setUnitIsInventory);
  const productType = useContractStore(x => x.productType);
  const setProductType = useContractStore(x => x.setProductType);
  const subproduct = useContractStore(x => x.subproduct);
  const setSubproduct = useContractStore(x => x.setSubproduct);
  const otherSubproduct = useContractStore(x => x.otherSubproduct);
  const setOtherSubproduct = useContractStore(x => x.setOtherSubproduct);
  const unitTypeOtherText = useContractStore(x => x.unitTypeOtherText);
  const setUnitTypeOtherText = useContractStore(x => x.setUnitTypeOtherText);
  const unitType = useContractStore(x => x.unitType);
  const setUnitType = useContractStore(x => x.setUnitType);
  const roofColor = useContractStore(x => x.roofColor);
  const setRoofColor = useContractStore(x => x.setRoofColor);
  const trimColor = useContractStore(x => x.trimColor);
  const setTrimColor = useContractStore(x => x.setTrimColor);
  const baseColor = useContractStore(x => x.baseColor);
  const setBaseColor = useContractStore(x => x.setBaseColor);
  const otherBaseColor = useContractStore(x => x.otherBaseColor);
  const setOtherBaseColor = useContractStore(x => x.setOtherBaseColor);
  const otherTrimColor = useContractStore(x => x.otherTrimColor);
  const setOtherTrimColor = useContractStore(x => x.setOtherTrimColor);
  const otherRoofColor = useContractStore(x => x.otherRoofColor);
  const setOtherRoofColor = useContractStore(x => x.setOtherRoofColor);
  const searchText = useContractStore(x => x.searchText);
  const setSearchText = useContractStore(x => x.setSearchText);
  const setWidthFeetOtherText = useContractStore(x => x.setWidthFeetOtherText);
  const setLengthFeetOtherText = useContractStore(x => x.setLengthFeetOtherText);
  const estimatedDeliveryDate = useContractStore(x => x.estimatedDeliveryDate);
  const setEstimatedDeliveryDate = useContractStore(x => x.setEstimatedDeliveryDate);
  const salesperson = useContractStore(x => x.salesperson);
  const setSalesperson = useContractStore(x => x.setSalesperson);
  const otherSalesperson = useContractStore(x => x.otherSalesperson);
  const setOtherSalesperson = useContractStore(x => x.setOtherSalesperson);
  const wasInitialCreation = useContractStore(x => x.wasInitialCreation);
  const setInventoryId = useContractStore(x => x.setInventoryId);
  const setDealer = useContractStore(x => x.setDealer);
  const widthFeet = useContractStore(x => x.widthFeet);
  const setWidthFeet = useContractStore(x => x.setWidthFeet);
  const resolveWidthFeet = useContractStore(x => x.resolveWidthFeet);
  const resolveLengthFeet = useContractStore(x => x.resolveLengthFeet);
  const lengthFeet = useContractStore(x => x.lengthFeet);
  const setLengthFeet = useContractStore(x => x.setLengthFeet);
  const heightFeet = useContractStore(x => x.heightFeet);
  const setHeightFeet = useContractStore(x => x.setHeightFeet);
  const savedAddons = useContractStore(x => x.savedAddons);
  const setUnitTypes = useContractStore(x => x.setUnitTypes);
  const setHideUnitType = useContractStore(x => x.setHideUnitType);
  const widthFeetOtherText = useContractStore(x => x.widthFeetOtherText);
  const lengthFeetOtherText = useContractStore(x => x.lengthFeetOtherText);
  const heightFeetOtherText = useContractStore(x => x.heightFeetOtherText);
  const setHeightFeetOtherText = useContractStore(x => x.setHeightFeetOtherText);
  const setDefaultUnitTypeId = useContractStore(x => x.setDefaultUnitTypeId);
  const setPorchColorId = useContractStore(x => x.setPorchColorId);
  const setTypeOfPorch = useContractStore(x => x.setTypeOfPorch);
  const typeOfPorch = useContractStore(x => x.typeOfPorch);
  const porchMax = useContractStore(x => x.porchMax);
  const setPorchMax = useContractStore(x => x.setPorchMax);
  const porchMin = useContractStore(x => x.porchMin);
  const setPorchMin = useContractStore(x => x.setPorchMin);
  const porchColorId = useContractStore(x => x.porchColorId);
  const porchWall1Length = useContractStore(x => x.porchWall1Length);
  const setPorchWall1Length = useContractStore(x => x.setPorchWall1Length);
  const porchWall2Length = useContractStore(x => x.porchWall2Length);
  const setPorchWall2Length = useContractStore(x => x.setPorchWall2Length);
  const porchWall3Length = useContractStore(x => x.porchWall3Length);
  const setPorchWall3Length = useContractStore(x => x.setPorchWall3Length);
  const porchWall4Length = useContractStore(x => x.porchWall4Length);
  const setPorchWall4Length = useContractStore(x => x.setPorchWall4Length);
  const fontSize = useContractStore(x => x.fontSize);
  const setFontSize = useContractStore(x => x.setFontSize);
  const rulerOffset = useContractStore(x => x.rulerOffset);
  const setRulerOffset = useContractStore(x => x.setRulerOffset);

  const [proposedSku, setProposedSku] = useState(null);
  const [searchingUnpaired, setSearchingUnpaired] = useState(false);
  const [updatingAddons, setUpdatingAddons] = useState(false);
  const [loadingSkuAddonOptions, setLoadingSkuAddonOptions] = useState(false);
  const [newAddOn, setNewAddOn] = useState(null);
  const [otherNewAddOnName, setOtherNewAddOnName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [invPairingMode, setInvPairingMode] = useState(false);
  const [executingPairing, setExecutingPairing] = useState(false);
  const [message, setMessage] = useState(null);
  const [isFirstLoadOfUnitOptions, setIsFirstLoadOfUnitOptions] = useState(true);
  //For FP
  const [showEditor, setShowEditor] = useState(false);
  const [selectedFPAddOns, setSelectedFPAddOns] = useState([]);
  const [mfgFPAddOnOptions, setMfgFPAddOnOptions] = useState([]);
  const [optionColors, setOptionColors] = useState([]);
  const [bundleOptions, setBundleOptions] = useState([]);

  useEffect(getUnpairedInventory, [unpairedInvList?.pageNumber])
  useEffect(() => {
    // if (loadingPage) return;
    getMfgSubproductSkuAddOnOptions();
  }, [manufacturerId, sku?.value])

// OBSOLETE
// useEffect(() => {
//   if (!props.contractData || isPairing) return;
//   let data = {...props.contractData};
//   if (props.lastPairedInventoryId && !data.subproductSku){
//     data.subproductSku = constants.OTHER_OPTION;
//   }
//   setUnitData(data);
// }, [props.contractData]);

// OBSOLETE
// useEffect(() => {
//   if (isPairing
//     || (!props.contractData && !props.contractData.manufacturer && !props.contractData.inventoryId)) return;
//   if (props.subproductTypes) {
//     setSubProducts(props.subproductTypes);
//     setBaseColors(props.baseColors);
//     setTrimColors(props.trimColors);
//     setRoofColors(props.roofColors);
//     setProductSkuOptions(props.subProductSkuOptions)
//   }
// }, [props.subproductTypes, props.subProductSkuOptions, props.baseColors]);

// useEffect(() => {
//   let newScreenWarnings = {};
//   _.each(props.fieldWarnings, w => Object.assign(newScreenWarnings, {[w.field]: w.text}))
//   setScreenWarnings(newScreenWarnings);
// }, [props.fieldWarnings]);

// useEffect(() => {
//   if (isPairing || (!manufacturer && !inventoryId)) return;
//   if (subproductTypes) {
//     setSubProducts(subproductTypes);
//     setBaseColors(baseColors);
//     setTrimColors(trimColors);
//     setRoofColors(roofColors);
//     setSkus(skus)
//   }
// }, [subproductTypes, skus, baseColors]);

  function getOtherAddOnOption() {
    return {
      id: constants.OTHER_ID,
      value: constants.OTHER_ID,
      name: constants.OTHER,
      label: constants.OTHER,
      addOnId: 0,
      addOnLength: 0,
      addOnName: null,
      addOnStandardPrice: 0,
      standardPrice: 0,
      addOnWidth: 0,
      deactivatedAt: null,
      defaultPrice: 0,
      manufacturerId: 0,
      manufacturerName: null,
      manufacturerSubProductId: 0,
      manufacturerSubProductSkuBasePrice: 0,
      manufacturerSubProductSkuId: 0,
      manufacturerSubProductSkuLength: 0,
      manufacturerSubProductSkuWidth: 0
    };
  }

  function transformAddOns(list, overrideSkuId = null) {
    const skuId = overrideSkuId
      ? overrideSkuId
      : sku?.value;
    return _.map(list, u => {
      const resolvedPrice = skuId === constants.OTHER_ID
        ? u.standardPrice
        : u.addOnStandardPrice;
      const label = u.id === constants.SELECT_OPTION_ID || u.id === constants.OTHER_ID
        ? u.name
        : `${u.name} - ${ui_helpers.formatCurrency(resolvedPrice)}`;
      return {
        ...u,
        label: label,
        value: u.id,
        resolvedPrice: resolvedPrice
      };
    });
  }

  function getUnpairedInventory() {
    if (searchingUnpaired || !searchText || searchText.length < 3 || isPairing) return;
    setSearchingUnpaired(true);
    const payload = {
      searchText: searchText,
      page: unpairedInvList ? unpairedInvList.pageNumber : 1,
      pageSize: 3
    };
    api.post('Inventory/GetMfgUnpairedInventoryList', payload).then(res => {
      if (res.data && res.data.success) {
        setUnpairedInvList(res.data.message)
      }
    }).catch(err => console.error(err))
    .finally(() => setSearchingUnpaired(false));
  }

  function deleteOption(o) {
    if (o.id === 0) {
      var removed = _.find(addOns, x => x.unique === o.unique);
      setAddOns(_.reject(addOns, x => x.unique === o.unique));
      if (removed && unitPriceDisabled)
      {
        setUnitPrice(unitPrice - removed.price);
      }
    } else {
      let payload = {addOnId: o.id};
      if (hasSku || sku) {
        payload.skuId = sku.value;
      }
      api.post('Contract/DeleteAddOn', payload).then(r => {
        if (r.data.success) {
          if ((isQuote || !enableBuildFeature) && hasSku) {
            setUnitPrice(r.data.message.price);
          }
          setAddOns(_.reject(addOns, x => x.id === o.id));
        } else {
          Alert.error(r.data.message);
        }
      }).catch((e) => console.error(e));
    }
  }

  function onAddOption() {
    if (newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT
      && (newAddOn.typeOfAddOn === constants.ADDON_TYPE_ID.OTHER || newAddOn.addOnTypeId === constants.ADDON_TYPE_ID.OTHER)
      && (!resolveLengthFeet() || !resolveWidthFeet()))
    {
      Alert.warning('Please enter a unit length and width before saving your add-on in order to calculate a correct Sq Ft price.');
      return;
    }
    const newAddOnList = mapAddOnToUnitOptions();
    if (!newAddOnList.length) return;
    setAddOns(_.concat(addOns, newAddOnList));
    onUpdateContractAddons(addOns);
    setOtherNewAddOnName("");
    setNewAddOn(null);
  }

  function mapAddOnToUnit(u) {
    const label = u.label === constants.OTHER
      ? otherNewAddOnName
      : u.label;
    let lengthInInches = 0;
    let widthInInches = 0;
    if (u.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT) {
      const wFt = resolveWidthFeet();
      widthInInches = wFt * 12;
      if (u.sqFt) {
        const sqFt = Number(u.sqFt);
        const lengthInFeet = sqFt / wFt;
        lengthInInches = lengthInFeet * 12;
      } else {
        lengthInInches = u.length; // in inches already here
      }
    } else if (u.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT) {
      lengthInInches = Number(u.length);
    } else if (u.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.PERCENT_OF_BASE) {
      console.log('change resolved price?', u.resolvedPrice, u.price);
    }
    const idValue = 0;
    return {
      id: idValue,
      value: idValue,
      addOnId: u.addOnId > 0 ? u.addOnId : idValue,
      price: u.resolvedPrice,
      name: label,
      description: u.description,
      seq: -1,
      bundleId: u.bundleId,
      showInFloorPlan: true,
      hasDimensions: true,
      length: lengthInInches,
      width: widthInInches,
      unique: randomInt(),
      label: label,
      positionX: u.positionX,
      positionY: u.positionY,
      rotation: u.rotation,
      typeOfUnitOfMeasure: u.typeOfUnitOfMeasure,
      unitOfMeasureId: u.typeOfUnitOfMeasure,
      swingTypeId: u.typeOfSwing || 0,
      typeOfSwing: u.typeOfSwing || 0,
      additionalOption1Price: u.additionalOption1Price,
      additionalOption2Price: u.additionalOption2Price,
      additionalOptionType1Price: u.additionalOption1Price,
      additionalOptionType2Price: u.additionalOption2Price,
      additionalOption1On: u.additionalOption1On,
      additionalOption2On: u.additionalOption2On,
      additionalOption1ColorId: u.additionalOption1ColorId,
      additionalOption2ColorId: u.additionalOption2ColorId
    };
  }

  function mapAddOnToUnitOptions() {
    if (!newAddOn) return [];
    if (newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT) {
      newAddOn.length = newAddOn.length * 12;
    } else if ((newAddOn.typeOfAddOn === constants.ADDON_TYPE_ID.OTHER || newAddOn.addOnTypeId === constants.ADDON_TYPE_ID.OTHER)
      && newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT) {
      // for other types that are sq. ft. UOM we assume length and width are building length and width
      // per Conrad, 12-Aug-23
      const length = resolveLengthFeet();
      const width = resolveWidthFeet();
      newAddOn.length = length * 12;
      newAddOn.width = width * 12;
      newAddOn.sqFt = length * width;
    } else if (newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.PERCENT_OF_BASE) {
      console.log('set resolved price here?', newAddOn.price, newAddOn.resolvedPrice)
    }
    const item = mapAddOnToUnit(newAddOn);
    let list = [];
    const qty = 1; // parseInt(unitData.qty, 10) || 1;
    for(var i=0; i<qty; i++) {
      list.push({...item});
    }
    return list;
  }

  function randomInt() {
    return Math.floor(Math.random() * 1000);
  }

  // function sizeOptions(dimension) {
  //   let list = [];
  //   switch(dimension) {
  //     case 'WIDTH':
  //       list = props.widths;
  //       break;
  //     case 'HEIGHT':
  //       list = props.heights;
  //       break;
  //     case 'LENGTH':
  //       list = props.lengths;
  //       break;
  //     default:
  //       return list;
  //   }
  //   if (productType && _.some(list, w => w.productTypeId === productType.value)) {
  //     return _.filter(list, w => w.productTypeId === productType.value);
  //   }
  //   // at this point we just return the default list (not productType specific)
  //   return _.filter(list, x => (x.productTypeId ? false : true));
  // }

  function onConfirmRepairing() {
    // setUnpairContractId(existingContractPairingContractId);
    setExistingContractPairingContractId(null);
  }

  function maybeCancelCaptive(onComplete) {
    if (shouldDeleteCaptiveInventory()) {
      api.post('contract/UnpairAndCancelCaptiveInventory', { id: contractId }).then(r => {
        if (r.data.success) {
          if (onComplete) {
            onComplete();
          }
        } else {
          Alert.error('An error occurred while attempting to delete the associated, captive inventory: ' + r.data.message);
        }
      }).catch((e) => Alert.error('An unexpected error occurred while attempting to delete the associated, captive inventory.'));
    } else if (onComplete) {
      onComplete();
    }
  }

  function shouldDeleteCaptiveInventory() {
    return wasInitialCreation && captiveInventoryId;
  }

  function tryPairInventory(probeSerialNumber) {
    api.post('inventory/QueryActiveInventoryBySerial', { SerialNumber_EXACT: probeSerialNumber }).then(r => {
      if (r.data.success) {
        setDisableSale(false);
        const existingContract = r.data.message.existingContract;
        const inv = r.data.message.inventory;
        if (existingContract && existingContract.id !== contractId)
        {
          // confirm unpairing
          setExistingContractPairingContractId(inv.contractId);
        } else
        {
          let confirmMessage = 'Active inventory has been found with this serial number.';
          if (shouldDeleteCaptiveInventory()) {
            confirmMessage = confirmMessage + ' However, this contract has a dedicated build associated. If you continue it will be deleted.';
          }
          confirmMessage = confirmMessage + ' Would you like to continue to pair this inventory and prefill all unit details?';
          confirmAlert({
            title: "Confirm Prefill",
            message: confirmMessage,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  // newUnitData.manufacturer = _.find(props.manufacturers, x => x.value === inv.manufacturerId);
                  if (inv.unitOptionList && inv.unitOptionList.length) {
                    inv.unitOptionList = _.map(inv.unitOptionList, x => ({ ...x, value: x.id, label: x.name, defaultPrice: x.price }));
                  }
                  doPairInventory(inv, probeSerialNumber);
                }
              },
              {
                label: "No"
              }
            ]
          });
        }
      } else {
        setValidationMessage({message: r.data.message, flavor: "warning"});
        setDisableSale(r.data.disableSale ? true : false);
        setTimeout(() => setValidationMessage(null), 5000);
      }
    }).catch((e) => console.error(e));
  }

  function onChangeSerialNumber(value) {
    setSerialNumber(value);
    if (!value || value.toUpperCase() === 'TBD') return;
    if (!captiveInventoryId) {
      tryPairInventory(value);
    }
  }

  function onChangeTaxRateString(value) {
    let newTaxRate = parseFloat(value);
    if (newTaxRate > 1.0) {
      newTaxRate /= 100.0;
    }
    newTaxRate = parseFloat(newTaxRate.toFixed(5));
    setTaxRate(newTaxRate);
    setTaxRateString(value);
  }

  function onChangeUnitPrice(value) {
    const newValue = ui_helpers.cleanseCurrencyCharacters(value);
    if (isQuote) {
      api.post('CashSale/UpdateQuoteUnitPrice', {contractId: contractId, amount: parseFloat(newValue)}).then(r => {
        if (!r.data.success) {
          Alert.error('There was an error saving the unit price.');
          return;
        }
        setUnitPrice(newValue);
      }).catch(err => Alert.error(err));
    } else {
      setUnitPrice(newValue);
    }
  }

  function onChangeSku(newValue) {
    if (newValue && newValue.defaultPrice && (!addOns || !addOns.length)) {
      setSku(newValue);
    } else {
      // prompt to verify the change & removal of existing add-ons
      setProposedSku(newValue);
    }
  }

  function onChangeNewInventory(value, fieldName) {
    if (fieldName === 'unitIsInventory') {
      if (value === true) {
        setUnitIsInventory(true);
      } else {
        if (customSerialEnabled) {
          setSerialNumber("");
        }
        if (captiveInventoryId) {
          // no change, as this is not allowed...
          Alert.warning('This agreement cannot be switched to Order Sale. If inventory is no longer the right choice you\'ll need to cancel the agreement and start again.');
        }
        else if (inventoryId)
        {
          confirmAlert({
            title: "Confirm Unpairing",
            message: 'This agreement is currently paired to inventory. Are you sure you wish to unpair that inventory and proceed with a new, order sale situation? If you choose to unpair, be SURE to change this agreement unit\'s serial number to avoid an automatic re-pairing by serial # match.',
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  api.post(`Inventory/UnpairContract/${inventoryId}`).then(r => {
                    if (r.data.success) {
                      setInventoryId(null);
                      setUnitIsInventory(false);
                    } else {
                      Alert.error('Unable to unpair due to an unexpected error: ' + r.data.message);
                    }
                  }).catch(api.catchHandler);
                }
              },
              {
                label: "No"
              }
            ]
          });
        } else {
          setUnitIsInventory(false);
        }
      }
    } else {
      setUnitIsNew(value);
      if (value === false) {
        setUnitIsInventory(true);
      }
    }
  }

  function getInventoryAddOnPrice(addOn) {
    if (!addOn.bundleId) {
      return ui_helpers.formatCurrency(addOn.defaultPrice);
    }
  }

  function addOnDisplayCells(addOn) {
    let additionalOptions = false;
    let name = addOn.name;
    let priceString = '';
    let priceString2 = '';
    if (addOn.bundleId) {
      priceString = 'Bundled Item';
    } else {
      let unitsString = " ea.";
      let addOnPrice = parseFloat(addOn.price || 0.00);
      if (addOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT) {
        unitsString = " per ft";
        const multiplier = parseFloat(addOn.length) / 12; // expressed in inches
        priceString2 =  `x${multiplier} = ${ui_helpers.formatCurrency(addOnPrice * multiplier)}`;
      }
      else if (addOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT)
      {
        unitsString = " per sq ft";
        const multiplier1 = parseFloat(addOn.length) / 12; // expressed in inches
        const multiplier2 = parseFloat(addOn.width) / 12; // expressed in inches
        priceString2 =  `x${multiplier1 * multiplier2} = ${ui_helpers.formatCurrency(addOnPrice * multiplier1 * multiplier2)}`;
      }
      else if (addOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.PERCENT_OF_BASE)
      {
        unitsString = " % of base";
      }
      else
      {
        if (addOn.additionalOption1On && addOn.additionalOptionType1Price) {
          addOnPrice += addOn.additionalOptionType1Price;
          additionalOptions = true;
        }
        if (addOn.additionalOption2On && addOn.additionalOptionType2Price) {
          addOnPrice += addOn.additionalOptionType2Price;
          additionalOptions = true;
        }
      }
      priceString = `${ui_helpers.formatCurrency(addOnPrice)} ${unitsString}`;
    }
    return (<Fragment>
      <td>{name}{additionalOptions ? " w/ options" : ""}</td>
      <td colSpan={2}>
        {addOn.bundleId
          ? (<span className='text-muted' style={{fontStyle: "italic"}}>{priceString}</span>)
          : null
        }
        {!addOn.bundleId
          ? (<Fragment>
              <div style={{fontSize: "0.9rem"}}>{priceString}</div>
              {priceString2
                ? (<div className='text-muted' style={{fontSize: "0.9rem"}}>{priceString2}</div>)
                : null
              }
            </Fragment>)
          : null
        }
      </td>
    </Fragment>);
  }

  function confirmPairInv(selectedInv) {
    if (shouldDeleteCaptiveInventory()) {
      confirmAlert({
        title: "Confirm Prefill",
        message: 'This contract has a dedicated build associated. If you continue it will be deleted. Are you certain that you wish to continue to pair this inventory, prefill all unit details and discard the previously associated inventory?',
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              doPairInventory(selectedInv);
            }
          },
          {
            label: "No"
          }
        ]
      });
    } else {
      doPairInventory(selectedInv);
    }
  }

  function applyInventoryValues(selectedInv) {
    setInventoryId(selectedInv.id ? selectedInv.id : selectedInv.inventoryId);
    setManufacturer(selectedInv.manufacturerId
                      ? { value: selectedInv.manufacturerId, label: selectedInv.manufacturerName }
                      : constants.OTHER_OPTION
                    );
    if (selectedInv.manufacturerId === constants.OTHER_ID) {
      setOtherManufacturer(selectedInv.manufacturerBrandOtherText);
    }
    setDealer({ value: selectedInv.dealerId, label: selectedInv.dealerName });
    setProductType(selectedInv.productTypeId
                    ? { value: selectedInv.productTypeId, label: selectedInv.productTypeName }
                    : constants.OTHER_OPTION
                  );
    setOtherSubproduct(selectedInv.unitManufacturerSubProductText);
    setOtherRoofColor(selectedInv.unitManufacturerRoofColorText);
    setOtherTrimColor(selectedInv.unitManufacturerTrimColorText);
    setOtherBaseColor(selectedInv.unitManufacturerBaseColorText);
    setUnitTypeOtherText(selectedInv.unitTypeName || selectedInv.unitTypeOtherText);
    setUnitIsNew(selectedInv.unitIsNew);
    setUnitIsInventory(true);
    setUnitType(selectedInv.unitTypeId && selectedInv.unitTypeName
                ? { value: selectedInv.unitTypeId, label: selectedInv.unitTypeName }
                : null);
    setSubproduct(selectedInv.unitManufacturerSubProductId && selectedInv.unitManufacturerSubProductId > 0
                  ? { value: selectedInv.unitManufacturerSubProductId, label: selectedInv.unitManufacturerSubProductText }
                  : constants.OTHER_OPTION
                );
    setSku((selectedInv.skuId || selectedInv.unitManufacturerSubProductSkuId)
            ? { value: selectedInv.skuId, label: selectedInv.unitManufacturerSubProductSkuName }
            : constants.OTHER_OPTION
          );
    setWidthFeet(selectedInv.unitWidthFeet || selectedInv.resolvedWidthFeet);
    setLengthFeet(selectedInv.unitLengthFeet  || selectedInv.resolvedLengthFeet);
    setHeightFeet(selectedInv.unitHeightFeet  || selectedInv.resolvedHeightFeet);
    setWidthFeetOtherText(selectedInv.unitWidthFeetOtherText || selectedInv.resolvedWidthFeet);
    setLengthFeetOtherText(selectedInv.unitLengthFeetOtherText || selectedInv.resolvedLengthFeet);
    setHeightFeetOtherText(selectedInv.unitHeightFeetOtherText || selectedInv.resolvedHeightFeet);
    if (selectedInv.associatedBundles) {
      setAssociatedBundles(selectedInv.associatedBundles);
    }
    if (selectedInv.serialNumber) {
      setSerialNumber(selectedInv.serialNumber);
    }
  }

  function doPairInventory(selectedInv, overrideSerialNumber = null) {
    setIsPairing(true);
    applyInventoryValues(selectedInv);
    let tmpContractAddOns = [];
    setExecutingPairing(true);
    const invId = selectedInv.id
      ? selectedInv.id
      : selectedInv.inventoryId;
    api.post(`inventory/GetInventoryAddonWithPrice/` + invId).then(res => {
      let newUnitPrice = unitPrice;
      if (res.data && res.data.success) {
        newUnitPrice = res.data.message.price || 0;
        tmpContractAddOns = res.data.message.addOnList.length
          ? _.map(res.data.message.addOnList, u => {
              return {
                ...u,
                id: 0,
                addOnId: u.addOnId > 0 ? u.addOnId : 0,
                unique: randomInt(),
              };
          })
          : [];
      }
      maybeCancelCaptive(() => {
        setAddOns(tmpContractAddOns);
        setUnitPrice(newUnitPrice);
        onUpdateContractAddons(tmpContractAddOns, false);
        setUnpairedInvList(null);
        setSearchText("");
        loadPairedInventoryLists(selectedInv.manufacturerId, selectedInv.productTypeId, selectedInv.unitManufacturerSubProductId, selectedInv.skuId, newUnitPrice, invId, selectedInv);
        setExecutingPairing(false);
        setInvPairingMode(false);
        setLastPairedInventoryId(invId);
      });
    })
    .catch(() => setExecutingPairing(false));
  }

  function onShowLayoutEditor() {
    if (!manufacturerId) {
      Alert.warning('A manufacturer must be selected in order to design a floor plan.');
      return;
    }
    api.post("Reference/GetMfgListForFloorPlan", {
        ManufacturerId: manufacturerId,
        SubProductSKUId: hasSku ? sku.value : null,
        InventoryId: null,
        QuoteContractId: isQuote ? Number(contractId) : null,
        ActiveOnly: true
      }).then(res => {
      if (res.data.success) {
        setSelectedFPAddOns(res.data.message.selectedAddOnOptions)
        setMfgFPAddOnOptions(res.data.message.addonOptions)
        setOptionColors(ui_helpers.idNameToValueLabel(res.data.message.optionColors, null, false));
        setBundleOptions(res.data.message.bundleOptions || []);
        setPorchColorId(res.data.message.mfgSku?.porchColorId || res.data.message.inventory?.porchColorId);
        // setPorchColorId(res.data.message.inventory?.porchColorId);
        setTypeOfPorch(res.data.message.mfgSku?.porchTypeId);
        setPorchMax(res.data.message.mfgSku?.porchMax);
        setPorchMin(res.data.message.mfgSku?.porchMin);
        setPorchWall1Length(res.data.message.mfgSku?.porchWall1Length);
        setPorchWall2Length(res.data.message.mfgSku?.porchWall2Length);
        setPorchWall3Length(res.data.message.mfgSku?.porchWall3Length);
        setPorchWall4Length(res.data.message.mfgSku?.porchWall4Length);
        setFontSize(res.data.message.inventory?.fontSize);
        setRulerOffset(res.data.message.inventory?.rulerOffSet);
      }
      setShowEditor(true);
    }).catch(err => console.error(err));
  }

  function renderFloorplan() {
    let skuBasePrice = 0;
    if (sku && sku.basePrice)
    {
      skuBasePrice = sku.basePrice;
    }
    else if (sku && sku.value && skus && skus.length)
    {
      const sps = _.find(skus, x => x.value === sku.value);
      skuBasePrice = sps
        ? sps.basePrice
        : unitPrice;
    }
    else
    {
      skuBasePrice = unitPrice;
    }
    const fakeInventory = {
      id: contractId,
      unitWidthFeet: widthFeet,
      unitWidthFeetOtherText: widthFeetOtherText,
      unitLengthFeet: lengthFeet,
      unitLengthFeetOtherText: lengthFeetOtherText,
      unitHeightFeet: heightFeet,
      unitHeightFeetOtherText: heightFeetOtherText,
      agreedPrice: agreedPrice,
      unitManufacturerSubProductSku: sku,
      basePrice: skuBasePrice,
      standardSkuBasePrice: skuBasePrice,
      typeOfPorch: typeOfPorch,
      porchMax: porchMax,
      porchMin: porchMin,
      porchWall1Length: porchWall1Length,
      porchWall2Length: porchWall2Length,
      porchWall3Length: porchWall3Length,
      porchWall4Length: porchWall4Length,
      porchColorId: porchColorId,
      rulerOffset: rulerOffset
      //standardRetailPrice: null
    };
    const exterior = floorplan_helpers.mapExteriorForFP(fakeInventory, constants.FPContext.contract);
    return (
      <FloorplanTool
        noInventory
        editingContext={constants.FPContext.contract}
        exterior={exterior}
        optionColors={optionColors}
        addOnOpts={floorplan_helpers.mapAddonOptionsForFP(mfgFPAddOnOptions, constants.FPContext.contract)}
        selectedAddOns={floorplan_helpers.mapSelectedAddonOptionsForFP(selectedFPAddOns, constants.FPContext.contract, exterior.height)}
        saveCallback={onFPSave}
        rulerOffset={fakeInventory.rulerOffset || floorplan_helpers.defaultRulerOffset}
        fontSize={fakeInventory.fontSize || floorplan_helpers.defaultFontSize}
        onExit={() => setShowEditor(false)}
        bundleOptions={floorplan_helpers.mapBundlesForFP(bundleOptions, constants.FPContext.contract)}
        modelName={ hasSku ? sku.label : serialNumber }
      />
    );
  }

  function onFPSave(exterior, selectedAddOns, rulerOffset, fontSize, imgUrl) {
    floorplan_helpers.saveFloorPlanChanges(
      constants.FPContext.contract,
      exterior,
      selectedAddOns,
      fontSize,
      rulerOffset,
      imgUrl,
      (newPrice, newAddOnList) => {
        _.each(newAddOnList, x => {
          x.label = x.addOnName;
          x.resolvedPrice = x.price;
          if (x.addOnTypeId === constants.ADDON_TYPE_ID.LOFT && !x.width) {
            x.width = exterior.height;
          }
        });
        setUnitPrice(newPrice);
        setAddOns(_.map(newAddOnList, mapAddOnToUnit));
      },
      null,
      unitPrice,
      hasSku ? sku.value : null
    );
  }

  function getMfgSubproductSkuAddOnOptions() {
    if (loadingSkuAddonOptions || isPairing) return;
    let url = '';
    if (!manufacturerId
      || manufacturerId === constants.OTHER_ID
      || !sku
      || !sku.value
    )
    {
      setAddOnOptions([
        { value: constants.SELECT_OPTION_ID, label: "Select Option" },
        constants.OTHER_OPTION
      ]);
    } else if (sku && sku.value === constants.OTHER_ID
      && manufacturerId !== constants.OTHER_ID)
    {
      url = 'contract/ListManufacturerAddons';
      const urlId = `${url}/${manufacturerId}`;
      // if (lastSkuAddonUrl === urlId) return;
      // setLastSkuAddonUrl(urlId);
      api.post(url, { activeOnly: true, id: manufacturerId }).then(r => {
        if (!r.data.success) return;
        let list = r.data.message;
        list = _.filter(list, addOn => !addOn.isDefault);
        if (!_.some(list, l => l.name === constants.OTHER)) {
          list.unshift(getOtherAddOnOption());
        }
        setAddOnOptions(transformAddOns(list));
      }).catch(api.catchHandler);
    }
    else if (hasSku)
    {
      url = `inventory/GetMfgProductSkuAddOnAndDefaultOptions/${manufacturerId}/${sku.value}`;
      if (!isPairing) {
        // indication that we need to perform an insert/update to apply default sku add-ons for this contract and related inventory
        url += "/" + contractId;
        if (props.convertFromQuote) {
          url += "/true";
        }
      }
      if (loadingSkuAddonOptions /* || url === lastSkuAddonUrl */) return;
      setLoadingSkuAddonOptions(true);
      api.fetch(url).then(r  => {
        if (!r.data) return;
        // setLastSkuAddonUrl(url);
        let list = r.data.mfgUnitOptions;
        list = _.filter(list, addOn => !addOn.isDefault);
        setAddOnOptions(transformAddOns(list));
        if (isPairing) return;
        if (_.some(savedAddons) && (!isQuote || isFirstLoadOfUnitOptions)) {
          if (isFirstLoadOfUnitOptions) {
            setIsFirstLoadOfUnitOptions(false);
          } else {
            onUpdateContractAddons(savedAddons);
          }
        } else {
          const defaultAddons = _.map(r.data.mfgDefaultSkuTemplateOptions, x => ({
            addOnId: x.addOnId,
            addOnTypeId: x.addOnTypeId,
            bundleId: x.bundleId,
            description: "",
            hasDimensions: true,
            id: 0,
            length: x.length,
            name: x.addOnName,
            typeOfUnitOfMeasure: x.unitOfMeasureId,
            price: x.price,
            // estimatedPrice: x.estimatedPrice,
            seq: 1,
            showInFloorPlan: true,
            width: x.width,
            isDefaultAddon: true,
            positionX: x.positionX,
            positionY: x.positionY,
            rotation: x.rotation,
            uniqueAddOnId: x.uniqueAddOnId,
            swingTypeId: x.typeOfSwing || 0,
            additionalOption1On: x.additionalOption1On,
            additionalOption2On: x.additionalOption2On,
            additionalOption1Price: x.additionalOption1Price,
            additionalOption2Price: x.additionalOption2Price,
            additionalOption1Type: x.additionalOption1Type,
            additionalOption2Type: x.additionalOption2Type
          }));
          onUpdateContractAddons(defaultAddons, !isQuote);
        }
      }).catch(err => console.error(err))
      .finally(()=> setLoadingSkuAddonOptions(false));
    }
  }

  function onUpdateContractAddons(list, readOnly = false
    // , newContractData = null
    ) {
    setUpdatingAddons(true);
    // const data = newContractData ? newContractData : contractData;
    const buildEffective = enableBuildFeature && unitIsNew && !unitIsInventory;
    let payload = {
      ReadOnly: readOnly,
      ContractId: contractId,
      AddonOptionList: list,
      UpdatePrice: (isQuote || !buildEffective) && hasSku
    };
    if (inventoryId) {
      payload.inventoryId = inventoryId;
    }
    if (hasSku) {
      payload.manufacturerSubProductSkuId = sku.value;
    }
    api.post("contract/UpdateContractAddonOption", payload).then(res => {
      if (!res.data || (res.data && !res.data.success)) {
        console.error("There was an error updating contract addons")
        return null;
      }
      // let unitPriceDisabled = false;
      // const oldDataHasSku = oldData.subproductSku
      //   && oldData.subproductSku.value
      //   && oldData.subproductSku.value !== constants.OTHER_ID;
      // const oldDataBuildEffective = enableBuildFeature && oldData.unitIsNew && !oldData.unitIsInventory;
      // if (lastPairedInventoryId) {
      //   unitPriceDisabled = true;
      // } else {
      //   unitPriceDisabled = (enableBuildFeature || isQuote)
      //     && oldDataHasSku;
      // }
      const shouldDisableUnitPrice = lastPairedInventoryId
        ? true
        : (enableBuildFeature || isQuote) && hasSku;
      if (shouldDisableUnitPrice || ((isQuote || !(enableBuildFeature && unitIsNew && !unitIsInventory)) && hasSku)) {
        setUnitPrice(res.data.message.price);
      }
      setAddOns(
        mapAddOnList(res.data.message.addOnList));
      if (payload.inventoryId) {
        setInventoryId(payload.inventoryId);
      }
    })
      // if (_.some(savedAddons)) {
      //   setSavedAddons([]);
      // }
    .catch(er => console.error(er))
    .finally(() => {
      setUpdatingAddons(false);
      setIsPairing(false);
    });
  }

  function mapAddOnList(list) {
    return _.map(list, (d) => {
      if (!d.addOnId) {
        d.addOnId = 0;
      }
      return d;
    });
  }

  function loadPairedInventoryLists(mfgId, productTypeId, subproductId, skuId, newUnitPrice, newInventoryId, selectedInv) {
    let skuOptions = skus.slice();
    let spOptions = subproductTypes.slice();
    let ptOptions = productTypes.slice();
    let bcOptions = baseColors.slice();
    let trimOptions = trimColors.slice();
    let roofOptions = roofColors.slice();

    return new Promise((resolve, reject) => {
      if (mfgId === manufacturer?.value && productTypeId === productType?.value) {
        return resolve();
      } else {
        if (mfgId === constants.OTHER_ID && (!productTypeId || productTypeId === constants.OTHER_ID)) {
          ptOptions = constants.PRODUCT_TYPES;
          setProductTypes(ptOptions);
          setProductType(constants.OTHER_OPTION);
        }
        if (mfgId && mfgId !== constants.OTHER_ID) {
          api
          .fetch(`contract/getFilteredProductTypes/${mfgId}`)
          .then(r => {
            if (r.data.success && r.data.message && r.data.message.length) {
              ptOptions = ui_helpers.idNameToValueLabel(r.data.message, null, false);
              setProductTypes(ptOptions);
              if (productTypeId && !_.some(ptOptions, x => x.value === productTypeId)) {
                setProductType(constants.OTHER_OPTION);
              }
              resolve();
            } else {
              reject();
            }
          })
          .catch(api.catchHandler);
        } else {
          resolve();
        }
      }
    })
    .then(() => {
      if (mfgId === manufacturer?.value && productTypeId === productType?.value) {
        return;
      } else {
        if (!mfgId || !productTypeId) {
          if (mfgId === constants.OTHER_ID && (!productTypeId || productTypeId === constants.OTHER_ID)) {
            spOptions = [constants.OTHER_OPTION];
            setBaseColors([constants.OTHER_OPTION]);
            setTrimColors([constants.OTHER_OPTION]);
            setRoofColors([constants.OTHER_OPTION]);
            setSubproductTypes(spOptions);
            setUnitTypes([constants.OTHER_OPTION]);
            setEnableBuildFeature(false);
            setEnableCustomSerialGeneration(false);
            setProductType(constants.OTHER_OPTION);
            setSubproduct(constants.OTHER_OPTION);
            setUnitType(constants.OTHER_OPTION);
            setRoofColor(constants.OTHER_OPTION);
            setTrimColor(constants.OTHER_OPTION);
            setBaseColor(constants.OTHER_OPTION);
            setSku(constants.OTHER_OPTION);
            setWidthFeet(widthFeetOtherText || widthFeet);
            setLengthFeet(lengthFeetOtherText || lengthFeet);
          }
          return;
        }
      }
    })
    .then(() => {
      if (subproductId === subproduct?.value) {
        return;
      } else {
        if (!subproductId || subproductId === constants.OTHER_ID) {
          skuOptions = [constants.OTHER_OPTION];
          setSkus(skuOptions);
          setSku(constants.OTHER_OPTION);
          return;
        }
      }
    })
    .then(() => {
      if (subproductId && subproductId > 0 && productTypeId > 0) {
        const url = `contract/GetManufacturerLists/${mfgId}/${productTypeId}/${subproductId}`;
        return api.fetch(url).then((r) => {
          bcOptions = ui_helpers.idNameToValueLabel(r.data.baseColorList, null, false);
          trimOptions = ui_helpers.idNameToValueLabel(r.data.trimColorList, null, false);
          roofOptions = ui_helpers.idNameToValueLabel(r.data.roofColorList, null, false);
          spOptions = ui_helpers.idNameToValueLabel(r.data.subproductTypeList, null, false);
          const changedUnitTypes = ui_helpers.idNameToValueLabel(r.data.unitTypeList, null, false);
          setUnitTypes(changedUnitTypes);
          setBaseColors(bcOptions);
          setTrimColors(trimOptions);
          setRoofColors(roofOptions);
          setSubproductTypes(spOptions);
          if (changedUnitTypes) setUnitTypes(changedUnitTypes);
          if (r.data.defaultUnitTypeId) setDefaultUnitTypeId(r.data.defaultUnitTypeId)
          setHideUnitType(r.data.hideUnitType)
          // we only set this based on the manufacturing setting here
          // if it has not already been determined by an existing, saved relationship from a paired inventory
          if (!newInventoryId) {
            setEnableBuildFeature(r.data.enableBuildFeature);
          }
          setEnableCustomSerialGeneration(r.data.enableCustomSerialGeneration);
          return;
        })
        .then(() => {
          if (_.find(bcOptions, option => option.name === selectedInv.unitManufacturerBaseColorText)) {
            _.find(bcOptions, option => {
              setBaseColor({ value: option.id, label: selectedInv.unitManufacturerBaseColorText });
            })
          }
          if (_.find(trimOptions, option => option.name === selectedInv.unitManufacturerTrimColorText)) {
            _.find(trimOptions, option => {
              setTrimColor({ value: option.id, label: selectedInv.unitManufacturerTrimColorText });
            })
          }
          if (_.find(roofOptions, option => option.name === selectedInv.unitManufacturerRoofColorText)) {
            _.find(roofOptions, option => {
              setRoofColor({ value: option.id , label: selectedInv.unitManufacturerRoofColorText });
            })
          }
        })
        .catch((e) => console.error(e));
      }
    })
    .catch(err => console.error('Error in pairing promise chain', err));
  }

  // const heightOptions = sizeOptions('HEIGHT');
  // const widthOptions = sizeOptions('WIDTH');
  // const lengthOptions = sizeOptions('LENGTH');
  const disableSKUChanges = !!(invPairingMode
    || (agreedPrice && inventoryId)
    || (!captiveInventoryId && inventoryId));

  return (
    <Fragment>
    <Form className="mt-2">
      {isLoading || executingPairing ? <Loading /> : (
      <Row>
        <Col>
          {captiveInventoryId ? null : (
            <FormGroup>
              <Label>
                Pair To Inventory?
                  <ToggleButton
                    value={invPairingMode}
                    activeLabel={"Yes"}
                    inactiveLabel={"No"}
                    colors={constants.TOGGLE_BUTTON_COLORS}
                    onToggle={(e) => {
                        if (invPairingMode) {
                          setUnpairedInvList(null);
                          setSearchText("");
                        }
                        setInvPairingMode(!e);
                      }
                    }
                  />
              </Label>
            </FormGroup>
          )}
          {invPairingMode ? (
            <>
              {searchingUnpaired ? (
                <Spinner size='sm' />
              ) : (
                <div>
                  <Row>
                    <Col xs={9}>
                      <Label>
                        Search Inventory <FontAwesomeIcon icon="info-circle" id="invSearchInfo"/>:
                        <UncontrolledTooltip
                          placement="right"
                          target="invSearchInfo"
                        >
                          Ex: Serial #, Invoice #, Base/Trim/Roof color, Manufacturer name
                        </UncontrolledTooltip>
                      </Label>
                      <DebounceInput
                        type="text"
                        min={3}
                        className="form-control"
                        debounceTimeout={300}
                        placeholder="Type at least 3 characters to search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </Col>
                    <Col xs={3}>
                      <Button size="sm" className="float-end mt-4" color="primary" onClick={getUnpairedInventory}>
                        Find
                      </Button>
                    </Col>
                  </Row>
                  {searchText && unpairedInvList ? (
                    <>
                      <Table>
                        <thead>
                          <tr>
                            <th>Results</th>
                            <th/>
                          </tr>
                        </thead>
                        <tbody>
                        {unpairedInvList.dataSource && unpairedInvList.dataSource.length
                          ? unpairedInvList.dataSource.map(i => (
                            <tr key={i.id}>
                              <td>
                                  <div><span className="boldData" >Serial Number:</span> {i.serialNumber}</div>
                                  <div className="small-text"><span className="boldData" >Product Type</span>: {i.productTypeName} | <span className="boldData" >Style:</span> {i.unitManufacturerSubProductText}</div>
                                  <div className="small-text"><span className="boldData" >Base:</span> {i.unitManufacturerBaseColorText} | <span className="boldData" >Roof:</span> {i.unitManufacturerRoofColorText} | <span className="boldData" >Trim:</span> {i.unitManufacturerTrimColorText}</div>
                                  <div className="small-text"><span className="boldData" >Manufacturer:</span> {i.manufacturerName}</div>
                                  <div className="small-text"><span className="boldData" >Dealer:</span> {i.dealerName}</div>
                                  <div className="small-text"><span className="boldData" >Invoice Number:</span> {i.invoiceNumber} | <span className="boldData" >Model Number:</span> {i.modelNumber}</div>
                              </td>
                              <td>
                                <Button
                                  size="sm"
                                  color="primary"
                                  onClick={() => confirmPairInv(i)}
                                >
                                  Select
                                </Button>
                              </td>
                            </tr>
                            ))
                          : (<tr>No Inventory Records Found</tr>)
                        }
                        </tbody>
                      </Table>
                      <Pager
                        pageNumber={unpairedInvList ? unpairedInvList.pageNumber : 1}
                        pageSize={unpairedInvList ? unpairedInvList.pageSize : 0}
                        totalResults={unpairedInvList ? unpairedInvList.totalItems : 0}
                        onSetPageCallback={(e) => setUnpairedInvList({...unpairedInvList, pageNumber: e})}
                      />
                    </>
                  ) : null}
                </div>
              )}
            </>
          ) : null}
          <FormGroup>
            <Label>
              Manufacturer {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.manufacturer ? screenWarnings.manufacturer : null}>
              <Select
                options={manufacturers}
                classNamePrefix={screenWarnings.manufacturer ? "invalidSelect" : null}
                value={manufacturer}
                onChange={(x) => setManufacturer(x)}
                isDisabled={invPairingMode}
              />
            </div>
            {manufacturer && manufacturer.value === constants.OTHER_ID ? (
              <div className="control-group">
                <Input type="text" className="mt-1" bsSize="sm" maxLength="150" placeholder="Other Details"
                  value={otherManufacturer}
                  onChange={(e) => setOtherManufacturer(e.target.value)}
                  disabled={invPairingMode} />
              </div>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label>Is this unit?</Label>
            <div className={classnames({"active": unitIsNew === true}, "badge badge-large badge-primary")}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                onChangeNewInventory(true, 'unitIsNew');
              }}>
              <Input type="radio" className="mt-0" name="new_or_used" checked={unitIsNew === true} onChange={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                onChangeNewInventory(true, 'unitIsNew');
              }} /> NEW
            </div>
            <div className={classnames({"active": unitIsNew === false}, "badge badge-large badge-clown")}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                onChangeNewInventory(false, 'unitIsNew');
              }}>
              <Input type="radio" className="mt-0" name="new_or_used" checked={unitIsNew === false} onChange={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                onChangeNewInventory(false, 'unitIsNew');
              }} /> USED
            </div>
          </FormGroup>
          <FormGroup>
            <Label>Unit is:</Label>
            <div
              disabled={unitIsNew === false}
              className={classnames({"active": unitIsInventory === true}, "badge badge-large badge-primary")}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                if (unitIsNew !== false) {
                  onChangeNewInventory(true, 'unitIsInventory');
                }
              }}>
              <Input type="radio" className="mt-0" name="sold_from_inv"
                disabled={unitIsNew === false}
                checked={unitIsInventory === true}
                onChange={(e) => {
                  e.nativeEvent.stopImmediatePropagation();
                  if (unitIsNew !== false) {
                    onChangeNewInventory(true, 'unitIsInventory');
                  }
                }} /> Inventory
            </div>
            <div
              disabled={unitIsNew === false}
              className={classnames({"active": unitIsInventory === false}, "badge badge-large badge-clown")}
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                if (unitIsNew !== false) {
                  onChangeNewInventory(false, 'unitIsInventory');
                }
              }}>
              <Input type="radio" className="mt-0" name="sold_from_inv"
                disabled={unitIsNew === false}
                checked={unitIsInventory === false}
                onChange={(e) => {
                  e.nativeEvent.stopImmediatePropagation();
                  if (unitIsNew !== false) {
                    onChangeNewInventory(false, 'unitIsInventory');
                  }
                }} /> Order Sale
            </div>
          </FormGroup>
          <FormGroup>
            <Label>
              Serial # {ui_helpers.requiredStar()} {lastPairedInventoryId ? <Badge color="success" title="Inventory Paired" className="ml-2">Inventory Paired</Badge> : null}
            </Label>
            <Input
              type="text"
              maxLength="50"
              title={screenWarnings.serialNumber ? screenWarnings.serialNumber : null}
              className={classnames({invalid: (screenWarnings.serialNumber ? true : false)})}
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
              onBlur={(e) => onChangeSerialNumber(e.target.value)}
              disabled={!isQuote && (invPairingMode || customSerialEnabled)}
              placeholder={customSerialEnabled && !isNewBuild ? "Serial Number will be generated" : ""}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              Product Type {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.productType ? screenWarnings.productType : null}>
              <Select
                classNamePrefix={screenWarnings.productType ? "invalidSelect" : null}
                options={productTypes}
                value={productType}
                onChange={(x) => setProductType(x)}
                isDisabled={invPairingMode || agreedPrice}
              />
            </div>
          </FormGroup>
          {!isQuote ? null : (
            <SalespersonEdit
              salespeople={salespeople}
              salesperson={salesperson}
              otherSalesperson={otherSalesperson}
              screenWarnings={screenWarnings}
              onChange={(newSalesperson) => setSalesperson(newSalesperson)}
              onDeleteSalesperson={props.onDeleteSalesperson}
            />
          )}
          {isRTO || isQuote ? null : (
            <>
              <FormGroup style={{clear: "both"}}>
                <div><Label>Estimated Delivery Date</Label></div>
                <div className="datePickerDiv">
                  <DatePicker
                    title={screenWarnings.estimatedDeliveryDate ? screenWarnings.estimatedDeliveryDate : null}
                    className={classnames({invalid: (screenWarnings.estimatedDeliveryDate ? true : false)}, 'form-control')}
                    selected={estimatedDeliveryDate
                      ? (
                      moment.isMoment(estimatedDeliveryDate)
                        ? estimatedDeliveryDate.toDate()
                        : estimatedDeliveryDate instanceof Date
                          ? estimatedDeliveryDate
                          : moment(estimatedDeliveryDate).toDate())
                      : new Date()}
                    onChange={(date) => setEstimatedDeliveryDate(date ? moment(date) : null)}
                    showMonthDropdown
                    showYearDropdown
                    withPortal
                    dropdownMode="select"
                  />
                </div>
              </FormGroup>
              <SalespersonEdit
                salespeople={salespeople}
                salesperson={salesperson}
                otherSalesperson={otherSalesperson}
                screenWarnings={screenWarnings}
                onChange={(newSalesperson) => setSalesperson(newSalesperson)}
                onDeleteSalesperson={props.onDeleteSalesperson}
              />
            </>
          )}
        </Col>
        <Col className={isQuote ? "form-col-even-quote" : "form-col-even"}>
          {disableSKUChanges && !captiveInventoryId ? (
            <div className="p-2 mt-2" style={{ backgroundColor: "#fff3cd", color: "#856404", borderRadius: "4px", border: "2px solid #ffeeba" }}>
              <FontAwesomeIcon icon="exclamation-circle" id="edit-warning" />{" "}
              To make any unit changes, please edit the paired inventory item and those changes will reflect here.
            </div>
          ) : null}
          <FormGroup>
            <Label>
              Style {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.subproduct ? screenWarnings.subproduct : null}>
              <Select
                classNamePrefix={screenWarnings.subproduct ? "invalidSelect" : null}
                options={subproductTypes}
                value={subproduct}
                onChange={(newSubproduct) => {
                  if (newSubproduct && !isPairing) {
                    setSubproduct(newSubproduct);
                    setSku(null);
                  }
                }}
                isDisabled={disableSKUChanges}
              />
            </div>
            {subproduct && subproduct.label === 'Other' ? (
              <div className="control-group">
                <Input type="text" bsSize="sm" className="mt-1" maxLength="150" placeholder="Other Details"
                  value={otherSubproduct}
                  onChange={(e) => setOtherSubproduct(e.target.value)}
                  disabled={invPairingMode || disableSKUChanges} />
              </div>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label>
              SKU / Size {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.sku ? screenWarnings.sku : null}>
              <Select
                classNamePrefix={screenWarnings.sku ? "invalidSelect" : null}
                options={skus}
                value={sku}
                onChange={(e) => onChangeSku(e)}
                isDisabled={disableSKUChanges}
              />
            </div>
            {sku && sku.value === constants.OTHER_ID ? (
              <div style={{minHeight: "50px", marginTop: "4px"}}>
                <span style={{float: "left", clear: "both", padding: "12px 3px 0 0", fontWeight: "bold"}}>W</span>
                  <div style={{float: "left", width: "80px", display: "inline-block", padding: "0 3px"}} title={screenWarnings.widthFeet ? screenWarnings.widthFeet : null}>
                    <div className="control-group">
                      <Input type="text" bsSize="sm" maxLength="20" value={widthFeetOtherText}
                        title={screenWarnings.widthFeet ? screenWarnings.widthFeet : null}
                        className={classnames({ invalid: (screenWarnings.widthFeet ? true : false) })}
                        onChange={(e) => setWidthFeetOtherText(e.target.value)} disabled={invPairingMode || disableSKUChanges} />
                    </div>
                  </div>
                  <span style={{float: "left", fontSize: "16pt"}}>'</span>
                  <span style={{float: "left", padding: "12px 3px 0 16px"}}>x</span>
                  <span style={{float: "left", padding: "12px 3px 0 0", fontWeight: "bold"}}>L</span>
                  <div style={{float: "left", width: "80px", display: "inline-block", padding: "0 3px"}} title={screenWarnings.lengthFeet ? screenWarnings.lengthFeet : null}>
                    <div className="control-group">
                      <Input type="text" bsSize="sm" maxLength="20"
                        value={lengthFeetOtherText}
                        onChange={(e) => setLengthFeetOtherText(e.target.value)}
                        title={screenWarnings.lengthFeet ? screenWarnings.lengthFeet : null}
                        className={classnames({ invalid: (screenWarnings.lengthFeet ? true : false) })}
                        disabled={invPairingMode} />
                    </div>
                  </div>
                  <span style={{float: "left", fontWeight: "bold", fontSize: "16pt"}}>'</span>
                  <span style={{float: "left", padding: "12px 3px 0 16px"}}>x</span>
                  <span style={{float: "left", padding: "12px 3px 0 0", fontWeight: "bold"}}>H</span>
                  <div style={{float: "left", width: "80px", display: "inline-block", padding: "0 3px"}} title={screenWarnings.heightFeet ? screenWarnings.heightFeet : null}>
                    <div className="control-group">
                      <Input
                        type="text"
                        bsSize="sm"
                        maxLength="20"
                        value={heightFeetOtherText}
                        onChange={(e) => setHeightFeetOtherText(e.target.value)}
                        disabled={invPairingMode}
                        placeholder="Optional"
                      />
                    </div>
                  </div>
                  <span style={{float: "left", fontWeight: "bold", fontSize: "16pt"}}>'</span>
              </div>
            ) : null}
          </FormGroup>
          {hideUnitType ? null : (
            <FormGroup>
              <Label>
                Material {ui_helpers.requiredStar()}
              </Label>
              <div title={screenWarnings.unitType ? screenWarnings.unitType : null}>
                <Select
                  classNamePrefix={screenWarnings.unitType ? "invalidSelect" : null}
                  options={unitTypes}
                  value={unitType}
                  onChange={(x) => setUnitType(x)}
                  isDisabled={invPairingMode || disableSKUChanges}
                />
              </div>
              {unitType && unitType.label === constants.OTHER ? (
                <div className="control-group">
                  <Input type="text" className="mt-1" bsSize="sm" maxLength="150" placeholder="Other Details"
                    value={unitTypeOtherText} onChange={(e) => setUnitTypeOtherText(e.target.value)}
                    disabled={invPairingMode || disableSKUChanges}
                  />
                </div>
              ) : null}
            </FormGroup>
          )}
          <FormGroup>
            <Label>
              Base Color {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.baseColor ? screenWarnings.baseColor : null}>
              <Select
                classNamePrefix={screenWarnings.baseColor ? "invalidSelect" : null}
                options={baseColors}
                value={baseColor}
                onChange={(x) => setBaseColor(x)}
                isDisabled={invPairingMode || disableSKUChanges}
              />
            </div>
            {baseColor && baseColor.label === constants.OTHER ? (
              <div className="control-group">
                <Input type="text" bsSize="sm" className="mt-1" maxLength="150" placeholder="Other Details"
                  value={otherBaseColor} onChange={(e) => setOtherBaseColor(e.target.value)} disabled={invPairingMode || disableSKUChanges}/>
              </div>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label>
              Trim Color {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.trimColor ? screenWarnings.trimColor : null}>
              <Select
                classNamePrefix={screenWarnings.trimColor ? "invalidSelect" : null}
                options={trimColors}
                value={trimColor}
                onChange={(x) => setTrimColor(x)}
                isDisabled={invPairingMode || disableSKUChanges}
              />
            </div>
            {trimColor && trimColor.label === constants.OTHER ? (
              <div className="control-group">
                <Input type="text" bsSize="sm" className="mt-1" maxLength="150" placeholder="Other Details"
                  value={otherTrimColor} onChange={(e) => setOtherTrimColor(e.target.value)} disabled={invPairingMode || disableSKUChanges}/>
              </div>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label>
              Roof Color {ui_helpers.requiredStar()}
            </Label>
            <div title={screenWarnings.roofColor ? screenWarnings.roofColor : null}>
              <Select
                classNamePrefix={screenWarnings.roofColor ? "invalidSelect" : null}
                options={roofColors}
                value={roofColor}
                onChange={(x) => setRoofColor(x)}
                isDisabled={invPairingMode || disableSKUChanges}
              />
            </div>
            {roofColor && roofColor.label === constants.OTHER ? (
              <div className="control-group">
                <Input type="text" bsSize="sm" className="mt-1" maxLength="150" placeholder="Other Details"
                  value={otherRoofColor} onChange={(e) => setOtherRoofColor(e.target.value)} disabled={invPairingMode || disableSKUChanges}/>
              </div>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <div className="mb-2">
            <Label>
              Unit Price {ui_helpers.requiredStar()}
            </Label>
            <DebounceInput
              type="text"
              min={3}
              className={classnames({ invalid: screenWarnings.unitPrice ? true : false }, "text-end form-control")}
              debounceTimeout={300}
              maxLength="15"
              style={{minWidth: "140px", width: "40%"}}
              title={screenWarnings.unitPrice ? screenWarnings.unitPrice : null}
              value={unitPriceDisabled ? ui_helpers.formatCurrency(unitPrice) : unitPrice}
              disabled={unitPriceDisabled}
              onChange={(e) => onChangeUnitPrice(e.target.value)}
            />
          </div>
          {isQuote ? (
            <>
              <div className="mb-1">
                <Label>
                  Custom Down Payment (Only if known)
                </Label>
                <DebounceInput
                  type="text"
                  min={3}
                  className="form-control"
                  debounceTimeout={300}
                  maxLength="15"
                  value={quoteDownPayment}
                  onChange={(e) => setQuoteDownPayment(e.target.value)}
                />
              </div>
              <PriceAdjustmentEditor
                addPriceAdjustment={props.addPriceAdjustment}
                deletePriceAdjustment={props.deletePriceAdjustment}
              />
              <Row className="mb-1">
                <Col xs="6">
                  <Label>Tax Rate</Label>
                </Col>
                <Col xs="6">
                  <DebounceInput
                    type="text"
                    min={3}
                    debounceTimeout={300}
                    maxLength="15"
                    title={screenWarnings.taxRate ? screenWarnings.taxRate : null}
                    value={taxRateString}
                    className={classnames({ invalid: screenWarnings.taxRate ? true : false }, "text-end")}
                    style={{ width: "80px", float: "left" }}
                    onChange={(e) => onChangeTaxRateString(e.target.value)}
                  />
                  <div
                    style={{
                      float: "left",
                      width: "50px",
                      paddingTop: "4px",
                    }}
                  >
                    {" "}
                    %
                  </div>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col xs="6">
                  <Label>Tax Amount</Label>
                </Col>
                <Col xs="6">
                  <Input
                    type="text"
                    bsSize="sm"
                    className="text-end"
                    readOnly
                    disabled
                    value={ui_helpers.formatCurrency(taxAmount)}
                  />
                </Col>
              </Row>
              <Row className={'mt-2'}>
                <Col>
                  <Button size="lg" color="dark" onClick={onShowLayoutEditor}>
                    Launch Add-Ons &amp; Layout Editor{" "}
                    <FontAwesomeIcon icon="arrow-right" />
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <div className={'mt-4'}>
              <FormGroup>
                <Label>Delivery Instructions</Label>
                <DebounceInput
                  element="textarea"
                  min={2}
                  className="form-control"
                  debounceTimeout={300}
                  rows="3"
                  maxLength="500"
                  value={deliveryInstructions}
                  onChange={(e) => setDeliveryInstructions(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <div title={screenWarnings.buildingOrientation ? screenWarnings.buildingOrientation : null}>
                <Label>Delivery Building Orientation {ui_helpers.requiredStar()}</Label>
                <Select
                  classNamePrefix={screenWarnings.buildingOrientation ? "invalidSelect" : null}
                  options={buildingOrientations}
                  value={buildingOrientation}
                  onChange={(x) => setBuildingOrientation(x)}
                />
                </div>
              </FormGroup>
            </div>
          )}
        </Col>
        {existingContractPairingContractId ? (
          <Modal isOpen={true}>
            <ModalHeader>
              <Button className="close float-right" dataDismiss="modal" ariaLabel="Close" onClick={() => setExistingContractPairingContractId(null)}>
                <FontAwesomeIcon icon="times-circle" />
              </Button>
              <h4 className="modal-title">Existing Contract Paired</h4>
            </ModalHeader>
            <ModalBody>
              This inventory item is currently paired with contract {existingContractPairing.existingContractAgreementNumber}.
            </ModalBody>
            <ModalFooter>
              <ButtonGroup className="float-right">
                <Button dataDismiss="modal" size="sm" onClick={() => setExistingContractPairingContractId(null)}>
                  Cancel
                </Button>
                <Button color="dark" size="sm" onClick={onConfirmRepairing}>
                  Unpair &amp; Replace
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </Modal>
        ) : null}
          <Col className={isQuote ? "form-col-even-quote" : "form-col-even"}>
          {message ? <div><RSAlert color={message.flavor}>{message.message}</RSAlert></div> : null}
          {unitIsNew === null ? null : (
            (!isNewBuild || !enableBuildFeature || isQuote) ? (
            <>
              <BundleInfo
                selectedSku={sku}
                manufacturer={manufacturer}
                data={{
                  contractAddOns: addOns,
                  associatedBundles: associatedBundles,
                  bundlesToDelete: bundlesToDelete,
                }}
                onChange={(changes) => {
                  setAddOns(changes.contractAddOns);
                  setBundlePrice(changes.bundlePrice);
                  setBundlesToDelete(changes.bundlesToDelete);
                  setAssociatedBundles(changes.associatedBundles);
                }}
                bundleContext={constants.BUNDLE_CONTEXT.contract}
                updateAddons={onUpdateContractAddons}
              />
              <div>
                <FormGroup>
                  <Row>
                    <Label>Unit Add-Ons</Label>
                    <Col xs={6} title={newAddOn ? newAddOn.label : ""}>
                      <Select
                        options={addOnOptions}
                        defaultValue={{value: constants.SELECT_OPTION_ID, label: "Select Option"}}
                        value={newAddOn}
                        onChange={(e) => {
                          if (e.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT) {
                            e.length = constants.DEFAULT_LINEAR_FOOT;
                          } else if (e.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT) {
                            e.sqFt = constants.DEFAULT_SQ_FT;
                          } else if (e.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.PERCENT_OF_BASE) {
                            console.log('set event params here?', e)
                          }
                          e.qty = 1;
                          setNewAddOn(e)
                        }}
                        isDisabled={unitPriceDisabled || (!isQuote && hasSku)}
                      />
                      {newAddOn && newAddOn.value === constants.OTHER_ID ? (
                        <div className="control-group">
                          <Input type="text" bsSize="sm" className="mt-1" maxLength="150" placeholder="Other Details"
                            value={otherNewAddOnName} onChange={(e) => setOtherNewAddOnName(e.target.value)} />
                        </div>
                      ) : null}
                    </Col>
                    <Col xs={6}>
                      {newAddOn && newAddOn.value !== constants.SELECT_OPTION_ID ? (
                        <>
                          <CurrencyInput
                            prefix={'$'}
                            decimalsLimit={2}
                            className={`form-control float-start`}
                            style={{width: "4rem", textAlign: "right"}}
                            value={newAddOn.resolvedPrice || 0.00}
                            placeholder="Price"
                            onValueChange={(e) => setNewAddOn({...newAddOn, resolvedPrice: e})}
                          />
                          {(newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT
                            || newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT)
                            && newAddOn.addOnTypeId !== constants.ADDON_TYPE_ID.OTHER
                            && newAddOn.typeOfAddOn !== constants.ADDON_TYPE_ID.OTHER
                              ? <div className="control-group">
                                  <CurrencyInput
                                    suffix={newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.LINEAR_FOOT
                                      ? 'ft'
                                      : 'sqft'}
                                    decimalsLimit={2}
                                    className='form-control float-start ms-1'
                                    style={{width: "70px", textAlign: "right"}}
                                    value={newAddOn.sqFt || newAddOn.length || 0}
                                    placeholder="# Feet"
                                    onValueChange={(e) => {
                                      let newState = {
                                        ...newAddOn
                                      };
                                      if (newAddOn.typeOfUnitOfMeasure === constants.UNITS_OF_MEASURE_ID.SQ_FOOT) {
                                        newState.sqFt = e;
                                      } else {
                                        newState.length = e;
                                      }
                                      setNewAddOn(newState);
                                    }}
                                  />
                                </div>
                              : null
                            }
                            {newAddOn.value !== constants.OTHER_ID || otherNewAddOnName
                              ? (<Button color="success" className="text-light float-end" onClick={onAddOption}>
                                  <FontAwesomeIcon icon="plus-circle" />
                                </Button>)
                              : null
                            }
                          </>)
                        : null
                      }
                    </Col>
                  </Row>
                </FormGroup>
                <Row>
                  <Col>
                    <Table>
                        <tbody>
                        {addOns && addOns.length
                            ? _.map(addOns, (u, idx) => (
                              <tr key={`uo${idx}-${u.id}`}>
                                {addOnDisplayCells(u)}
                                <td>
                                  {/* {u.bundleId
                                    ? (<Button
                                          size="sm"
                                          color="danger"
                                          className="text-white float-end"
                                          onClick={() => deleteBundle(u.bundleId)}
                                        >
                                        <FontAwesomeIcon icon="times-circle" /> B
                                      </Button>)
                                    : null
                                  } */}
                                  {!u.bundleId && (isQuote || !unitPriceDisabled)
                                    ? (<Button
                                          size="sm"
                                          color="danger"
                                          className="text-white float-end"
                                          onClick={() => deleteOption(u)}
                                        >
                                        <FontAwesomeIcon icon="times-circle" />
                                      </Button>)
                                    : null
                                  }
                                </td>
                              </tr>))
                            : null
                        }
                        </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            </>
          ) :  <div><Row><Col className="p-3"><AddOnAdvice text={`Add-Ons will be added in the Build step`}/></Col></Row></div>
          )}
        </Col>
      </Row>)}
      <Modal isOpen={proposedSku !== null} toggle={() => setProposedSku(null)}>
        <ModalHeader>Confirm SKU Size Change</ModalHeader>
        <ModalBody>
            Changing the SKU Size will remove the current list of unit options. Are you sure you want to proceed?
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button color="secondary" onClick={() => setProposedSku(null)}>No</Button>
            <Button color="primary" onClick={() => {
              setSku(proposedSku);
              setProposedSku(null);
            }}>Yes</Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    </Form>
    {showEditor && (
      <div style={constants.popOutStyle}>
        {renderFloorplan()}
      </div>
    )}
    </Fragment>
  );
};
